<template>
  <div class="location-card">
    <div class="location-head">
      <div class="location-title">{{ location.name }}</div>
      <q-btn flat dense>
        <q-icon name="fas fa-ellipsis-h" color="grey-7"></q-icon>
        <q-menu content-class="text-grey-7" auto-close>
          <q-list style="min-width: 150px">
            <q-item
              clickable
              v-for="(item, index) in locationActions"
              :key="index"
              @click="item.method(location)"
            >
              <q-item-section>{{ item.name }}</q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-btn>
    </div>
    <div class="location-address">
      <div class="location-address-value">
        <q-icon name="fas fa-map-marker-alt"></q-icon>
        {{ location.address }}
      </div>
      <div class="location-zip-code">
        <div class="location-zip">
          ZIP:
          <span>{{ location.zip }}</span>
        </div>
        <div class="location-code" v-if="location.code">
          CODE:
          <span>{{ location.code }}</span>
        </div>
      </div>
      <div class="location-address-city-state">
        {{
          location && location.city && location.city.name
            ? location.city.name
            : ""
        }}
        /
        {{
          location && location.state && location.state.name
            ? location.state.name
            : ""
        }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../axios/index";
export default {
  data() {
    return {
      locationActions: [
        {
          name: "Delete",
          method: this.remove,
        },
        {
          name: "Edit",
          method: this.editFunc,
        },
      ],
    };
  },
  props: {
    location: Object,
    index: Number,
  },
  methods: {
    editFunc(location) {
      this.edit = true;
      this.selectedLocation = location;
    },
    remove(location) {
      this.selectedLocation = location;
      this.confirm = true;
    },
  },
  computed: {
    selectedLocation: {
      get() {
        return this.$store.state.location.selectedLocation;
      },
      set(val) {
        this.$store.commit("location/SELECTED_LOCATION", val);
      },
    },
    confirm: {
      get() {
        return this.$store.state.location.confirm;
      },
      set(val) {
        this.$store.commit("location/SET_CONFIRM", val);
      },
    },
    edit: {
      get() {
        return this.$store.state.location.edit;
      },
      set(val) {
        this.$store.commit("location/SET_EDIT", val);
      },
    },
  },
  watch: {
    confirm(n, o) {
      !n ? (this.selectedLocation = {}) : "";
    },
  },
};
</script>

<style lang="scss">
.location-container {
  display: flex;
  flex-flow: row wrap;
  flex: 1;
  .location-card {
    background: #fff;
    margin: 5px;
    flex: 0 1 calc(50% - 10px);
    box-shadow: 0 0 20px #ccc;
    border-radius: 5px;
    padding: 10px;
    color: #bbb;
    .location-head {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      .location-title {
        font-size: 16px;
        flex: 1;
        color: #000;
        font-weight: 700;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
    .location-address {
      font-size: 15px;
      padding: 5px 0px;
      display: flex;
      flex-flow: column nowrap;
      .location-address-value {
        padding: 2px 0px;
        color: #bbb;
        overflow: hidden;
        font-weight: 300;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .location-zip-code {
        font-weight: 300;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        padding: 2px 0px;
        display: flex;
        flex: 1;
        .location-zip {
          font-weight: 700;
          flex: 1;
          text-align: left;
          span {
            font-weight: 300;
          }
        }
        .location-code {
          flex: 1;
          text-align: right;
          font-weight: 700;
          span {
            font-weight: 300;
          }
        }
      }
      .location-address-city-state {
        display: flex;
        justify-content: flex-end;
        font-weight: bold;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .location-container {
    display: flex;
    flex-flow: column nowrap;
    flex: 1;
  }
}

@media screen and (min-width: 1024px) {
  .location-address-value {
    height: 75px;
  }
}
</style>
